var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.3918 4.95941C7.71772 3.9035 9.31485 3.24343 10.9994 3.05518V13.0002H20.9444C20.7561 14.6847 20.096 16.2818 19.0401 17.6077C17.9842 18.9337 16.5754 19.9345 14.9757 20.495C13.3761 21.0556 11.6507 21.1531 9.99813 20.7763C8.34554 20.3995 6.83293 19.5637 5.63438 18.3652C4.43583 17.1666 3.60007 15.654 3.22327 14.0014C2.84647 12.3488 2.94395 10.6234 3.5045 9.0238C4.06505 7.42417 5.06588 6.01533 6.3918 4.95941Z",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.00021H20.488C20.0391 7.73482 19.3135 6.58555 18.3641 5.63615C17.4147 4.68674 16.2654 3.96114 15 3.51221V9.00021Z",
    stroke: "#161616",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.820f3bf4ac90e763b1f83209a611388c.svg";
export { ForwardRef as ReactComponent };